import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const onboardingFlowchartRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "onboarding/flowchart",
}).lazy(() => import("./Flowchart.lazy").then((d) => d.Route));
